// stores/environmentStore.ts
import { defineStore } from 'pinia'

export const useConfigStore = defineStore('configStore', {
  state: () => ({
    environments: [] as any, // or replace 'any' with the actual expected type
    inventorySources: [] as any,
    vendors: [] as any,
  }),
  actions: {
    async fetchDataEnvironment() {
      try {
        const response = await $fetch<{ success: boolean; data?: object; message?: string }>('/api/setting/environment')

        if (!response.success) {
          throw new Error('Failed to fetch environment data')
        }

        this.environments = response.data ?? []
      } catch (error) {
        console.error('Error fetching environment data:', error)
        this.environments = [] // Reset data on error
      }
    },
    async fetchDataInventorySources() {
      try {
        const response = await $fetch<{ success: boolean; data?: object; message?: string }>(
          '/api/setting/inventory-sources',
        )

        if (!response.success) {
          throw new Error('Failed to fetch inventory-sources data')
        }

        this.inventorySources = response.data ?? []
      } catch (error) {
        console.error('Error fetching inventory-sources data:', error)
        this.inventorySources = [] // Reset data on error
      }
    },

    async fetchDataVendors() {
      try {
        const response = await $fetch<{ success: boolean; data?: object; message?: string }>(
          '/api/setting/vendor-full-data',
        )

        if (!response.success) {
          throw new Error('Failed to fetch vendors data')
        }

        this.vendors = response.data ?? []
      } catch (error) {
        console.error('Error fetching vendors data:', error)
        this.vendors = [] // Reset data on error
      }
    },
    async initConfig() {
      // Initialize configuration data
      this.fetchDataEnvironment()
      this.fetchDataInventorySources()
      this.fetchDataVendors()
    },
  },
})
